// All JS that is needed only for logged out users

const SNOWPLOW_RETRY_MAX = 5;

// toggleVisibleHeader - used to share functionality between mobile menu icon onClick and visibleHeader onScroll
const toggleVisibleHeader = function (mode) {
    if (mode === "dark") {
        if (page_info.eap_co_brand) {
            filename = assets_app_version('//' + page_info.cdn_host_assets + '/eap/' + page_info.eap_code_name + '/' + page_info.product_code_name + '/logo.png');
            if ($('.header-eap-logo img').attr('src') === filename) {
                return;
            }
            $('.header-eap-logo img').attr('src', filename);
        } else {
            filename = assets_app_version('//' + page_info.cdn_host_assets + '/brand/betterhelp/icon-color-2024.png');
            if ($('.hidden-sm .brand img').attr('src') === filename) {
                return;
            }
            $('.hidden-sm .brand img').attr('src', filename);
        }
        $("header").addClass("scroll-header");
        $(".header-cta").removeClass("hide");
    }

    if (mode === "light") {
        if ($(".mobilemenu-toggle").attr("data-expanded") === "true" && $(window).scrollTop() < 50) {
            return;
        }

        if ($(".mobilemenu-toggle").attr("data-expanded") !== "true") {
            if ((page_info.eap_co_brand) || (page_info.redesigned_funnel === "betterhelp_two") || (page_info.template == "redesigned/gift")) {
                filename = assets_app_version('//' + page_info.cdn_host_assets + '/eap/' + page_info.eap_code_name + '/' + page_info.product_code_name + '/logo-light.png');
                if ($('.header-eap-logo img').attr('src') === filename) {
                    return;
                }
                $('.header-eap-logo img').attr('src', filename);
            } else {
                filename = assets_app_version('//' + page_info.cdn_host_assets + '/brand/betterhelp/logo_reverse_medium-2024.png');
                if ($('.hidden-sm .brand img').attr('src') === filename) {
                    return;
                }
                $('.hidden-sm .brand img').attr('src', filename);
            }
    
            $("header").removeClass("scroll-header");
            $(".header-cta").addClass("hide");
        }
    }
}

const toggleVisibleHeaderRedesign = function (mode) {
    const filenames = {
        whiteLogoWithText: assets_app_version(`//${page_info.cdn_host_assets}/brand/betterhelp/logo_reverse_medium-2024.png`),
        whiteLogoWithoutText: assets_app_version(`//${page_info.cdn_host_assets}/brand/betterhelp/icon-reverse-md-2024.png`),
        colorLogoWithText: assets_app_version(`//${page_info.cdn_host_assets}/brand/betterhelp/icon-color-2024.png`),
        colorLogoWithoutText: assets_app_version(`//${page_info.cdn_host_assets}/brand/betterhelp/icon-color-md-2024.png`),
    };

    const targetEls = {
        mobileDesktopImg: $('header .brand-logo img'),
        tabletImg: $('header .brand-icon img'),
    };

    if (mode === "dark") {
        if (targetEls.mobileDesktopImg.attr('src') !== filenames.colorLogoWithText) {
            targetEls.mobileDesktopImg.attr('src', filenames.colorLogoWithText)
        }

        if (targetEls.tabletImg.attr('src') !== filenames.colorLogoWithoutText) {
            targetEls.tabletImg.attr('src', filenames.colorLogoWithoutText)
        }

        $("header").removeClass("dark-bg");
        $("header").addClass("scroll-header");
        $(".header-cta").removeClass("hide");
    }

    if (mode === "light") {
        if (targetEls.mobileDesktopImg.attr('src') !== filenames.whiteLogoWithText) {
            targetEls.mobileDesktopImg.attr('src', filenames.whiteLogoWithText)
        }

        if (targetEls.tabletImg.attr('src') !== filenames.whiteLogoWithoutText) {
            targetEls.tabletImg.attr('src', filenames.whiteLogoWithoutText)
        }

        $("header").removeClass("scroll-header");
        $("header").addClass("dark-bg")
        $(".header-cta").addClass("hide");
    }
}
// visibleHeader - used for creating a floating navigation bar
var visibleHeader = function () {
    if ($(window).scrollTop() > 50) {
        if (page_info.redesigned_funnel === "betterhelp_two" || page_info.redesigned_home === "betterhelp_two" || page_info.template == "redesigned/gift" || page_info.template == "redesigned/counselor_application") {
            toggleVisibleHeaderRedesign("dark")
        } else {
            toggleVisibleHeader("dark")
        }
        $("header").attr("data-scrolled", true)
    } else {
        if (page_info.redesigned_funnel === "betterhelp_two" || page_info.redesigned_home === "betterhelp_two" || page_info.template == "redesigned/gift" || page_info.template == "redesigned/counselor_application") {
            if ($(".mobilemenu-toggle").attr("data-expanded") !== "true") {
                toggleVisibleHeaderRedesign("light")
            }
        } else {
            toggleVisibleHeader("light")
        }
        if ($("header").attr("data-scrolled") === "true") {
            $("header").attr("data-scrolled", false)
        }
    }
};

const set_snowplow_multi_cookie = function(retry) {
    retry = retry || 0;
    // multi-cookie for snowplow
    if (typeof snowplow_global != 'undefined' && snowplow_global != null) {
        var sp_cookie = snowplow_global.getCookieName('id');
        var snowplow_id = get_cookie(sp_cookie);
        if (snowplow_id) {
            if (!page_info.is_qa_server && page_info.product_code_name !== 'betterhelporg') { // we don't want to set sister site cookies on betterhelporg
                page_info['sites_fqdn'].forEach(function (site_fqdn) {
                    if (site_fqdn !== window.location.hostname) {
                        $.ajax({
                            url: 'https://' + site_fqdn + '/api/multi_cookie/',
                            type: "GET",
                            xhrFields: { withCredentials: true },
                            data: {
                                session_id: snowplow_id,
                                action: 'set_snowplow_id',
                            }
                        });
                    }
                });
            }
        }
    } else {
        if (retry <= SNOWPLOW_RETRY_MAX) {
            setTimeout(() => {
                set_snowplow_multi_cookie(retry + 1);
            }, 1000);
        }
    }
}

$(document).ready(function () {

    // track multi_click, all sites
    if (get_cookie('ms_click_tracker') == null) {
        if (!page_info.is_qa_server) {
            page_info['sites_fqdn'].forEach(function (site_fqdn) {
                if (site_fqdn !== window.location.hostname) {
                    $.ajax({
                        url: 'https://' + site_fqdn + '/api/multi_cookie/',
                        type: "GET",
                        xhrFields: { withCredentials: true },
                        data: {
                            session_id: page_info['uniqid'],
                            action: 'set_mc_id',
                        }
                    });
                }
            });
        }
        set_performance_cookie('bh_mc_id', page_info['uniqid']);
    }

    function set_performance_cookie(name, value) {
        $.ajax({
            url: 'https://' + window.location.hostname + '/api/set_performance_cookie',
            type: 'POST',
            data: {
                csrf_token: page_info.csrf_token,
                cookie_name: name,
                cookie_value: value,
            }
        });
    }

    set_snowplow_multi_cookie();

    if ($("input[name=timezone]").length) {
        var tz = jstz.determine();
        $("input[name=timezone]").val(tz.name());
    }

    if ($("#cookie-footer").length > 0) {
        $("#cookie-consent-accept-all").one('click', function () {
            set_cookie('cookie_consent_shown', true, 365 * 86000);
            $(".cookie-footer").addClass('hidden');
            return false;
        });

        $("#cookie-consent-close").one('click', function () {
            set_cookie('cookie_consent_shown', true, 365 * 86000);
            $(".cookie-footer").addClass('hidden');
            return false;
        });
    }

    switch (page_info.template) {

        case 'login':
            if (page_info.hasOwnProperty('login_from_email')) {
                var loginFromEmail = document.createElement("input");
                loginFromEmail.setAttribute("type", "hidden");
                loginFromEmail.setAttribute("name", "email_type");
                loginFromEmail.setAttribute("value", page_info.login_from_email);
                $('#login-form').append(loginFromEmail);
            }
            if (window.location.hash == '#autosave') {
                $('#modal-auto-save').modal('show');
            }

            $('#testimonial-slider').on("init", function (slick) {
                var t_offset = $(".testimonials").offset().top;
                var l_offset = $("#login-form").offset().top + $("#login-form").height();
                var q_offset = 0;
                if ($(".quote").length) {
                    q_offset = $(".quote").offset().top + $("#login-form").height();
                }
                if (t_offset > l_offset && t_offset > q_offset) {
                    $(".testimonials").css('visibility', 'visible');
                }
            });

            $('#testimonial-slider').slick({
                dots: true,
                accessibility: true,
                infinite: false,
                adaptiveHeight: false,
                arrows: false,
                swipe: false,
                swipeToSlide: false,
                autoplay: true,
                autoplaySpeed: 3000
            });

            if (!navigator.cookieEnabled) {
                $('#enable-cookies').modal('show');
            }
            break;

        case 'start-go2':
            $('#content-container').addClass('yellow-bg-container');
            $('#upperbar').addClass('yellow-bg-container');
            break;
    }

    if ($('#early_comparison_chart').length > 0) {
        var should_check_window_position = true;

        $(document).on('scroll', function () {
            if (should_check_window_position) {
                should_check_window_position = false;
                setTimeout(function () {
                    if ($(this).scrollTop() > $('#early_comparison_chart').position().top) {
                        $(document).unbind('scroll');
                    }
                    should_check_window_position = true;
                }, 1000);
            }
        })
    }
});

